// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__JpFly","boxTitle":"Qualiphy_boxTitle__DF7IA","box":"Qualiphy_box__2GQLv","toggleWrap":"Qualiphy_toggleWrap__lOaL_"};